export const iconFontAwesomeAlphabetT = (
	<i className="fa-solid fa-t"></i>
);
